import { ref } from '@vue/composition-api'

// 比赛详情页 market group 导航
export function useMarketGroup() {
  // 当前 market group
  const marketGroup = ref('')

  const updateMarketGroup = (group = '') => {
    marketGroup.value = group
  }

  return {
    marketGroup,
    updateMarketGroup
  }
}
